export const ATTRIBUTES = {
  STANDARD_CODE: 'Standard ID',
  STATUS: 'Status',
  OWNER: 'Owner',
  STANDARDS: 'Standards',
  EXTERNAL_LINKS: 'External Links',
  CLUSTER: 'Cluster',
  CLUSTERS: 'Clusters',
  DEADLINE: 'Deadline',
  CREATED_AT: 'Created At',
  RELATED_CONTROL: 'Related Control',
}
export const EXTERNAL_LINKS = 'External Links'
export const FILES = 'Files'
export const NO_NAME = 'No Name Provided'
